import React from 'react';

const Loading = () => <div className="loading" />;

export default Loading;
